import { useEffect } from 'react';

/**
 * Locks document.body scroll while the modal is active.
 * Pass `active = false` for modals that use an isOpen prop
 * and return null early (the hook still runs, so we need the gate).
 */
export function useBodyScrollLock(active = true) {
  useEffect(() => {
    if (!active) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, [active]);
}
